import NotificationPopUpContainer from './NotificationPopUpContainer';
export default NotificationPopUpContainer;
